import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import Theme from 'App.theme';
import * as FileUploadStyles from 'components/FileUpload/FileUpload.styles';
import { TableContainer } from 'components/Table/Table';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const DropTableContainer = styled(TableContainer)`
  max-height: 100%;
`;

export const DropTableWrapper = styled.div`
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(115, 115, 115, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 24px 40px;
`;

export const CustomLink = styled(Link)`
  text-decoration: none;
`;

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  max-width: 80%;
  padding: 20px;
  margin: 0 auto;
`;

export const FileUploadContainer = styled(FileUploadStyles.FileUploadContainer)<{ error: boolean }>`
  width: 100%;
  border-color: ${props => (props.error ? Theme.status.REJECTED : Theme.greys.GREY2)};
`;

export const FileUploadRoot = styled(FileUploadStyles.FileUploadRoot)`
  padding: 50px 20px;
`;

export const ProgressBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 30px;
  position: relative;
  width: 100%;
  border-radius: 1rem;
  border: 2px solid ${Theme.greys.GREY1};
  margin-top: 8px;
`;

export const MetaGrid = styled(Grid)`
  border: 1px solid black;
  background-color: white;
  padding: 12px;
  flex-grow: 1;
`;

export const FileUploadButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem;
`;

export const FileUploadListItemIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
`;

export const FileUploadFilterBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 1rem 0;
`;

export const FileUploadFilterSearchContainer = styled.div`
  width: 50%;
`;

export const FileUploadFilterDropdownsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 50%;
  justify-content: end;
  align-items: center;
`;
